module.exports = LazyLoad;